import antd, { Form, Collapse, Row, Col } from 'antd';
import * as React from 'react';
import styled from 'styled-components';
import ScreenHelper from '../../../Styled/ScreenHelper';
import { ColSize } from 'antd/lib/col';

export const LeftAlignUl = styled('ul')`
  text-align: left;
`;

declare type ColSpanType = ColSize;

export const ColLayout: { [key: string]: ColSpanType } = {
  xs: { span: 22, offset: 1 },
  sm: { span: 22, offset: 1 },
  md: { span: 10, offset: 1 },
  lg: { span: 10, offset: 1 },
  xl: { span: 10, offset: 1 },
};

export const ReCaptchaColLayout: { [key: string]: ColSpanType } = {
  xs: { span: 8, offset: 1 },
  sm: { span: 16, offset: 1 },
  md: { span: 10, offset: 6 },
  lg: { span: 10, offset: 6 },
  xl: { span: 10, offset: 6 },
};
